import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import {
    suppliesCategoryListRequest, addSuppliesCategoryRequest, addSuppliesCategoryRequestStatus,
    updateSuppliesCategoryDetailRequest, updateSuppliesCategoryDetailRequestStatus
} from '../../../redux/supplies/supplies.action'
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import { API_CONSTANTS, APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import CommonCheckbox from "../../../components/common-checkbox/commonCheckbox";
import Modal from 'react-bootstrap/Modal';
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import SubTextLabel from "../../../components/label/sub-text-label/subTextLabel";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";

const SuppliesCategoriesList = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { addSuppliesCategorySuccess, addSuppliesCategoryError, addSuppliesCategoryReqStatus,
        suppliesCategoryListSuccess, suppliesCategoryListError,
        updateSuppliesCategoryDetailSuccess, updateSuppliesCategoryDetailError, updateSuppliesCategoryDetailReqStatus } = useSelector(state => state.supplies)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [showAddCategoryModal, setShowAddCategoryModal] = useState(false)
    const [showUpdateCategoryModal, setShowUpdateCategoryModal] = useState(false)
    const [selectedCategory, setSelectedCategory] = useState(null)
    const [name, setName] = useState('')
    const [isActive, setIsActive] = useState(false)

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.SUPPLIES_ITEM_CATEGORIES_LIST, true)
            fetchBusinessList()
        } else if (isLoggedInUserEmployee(user)) {
            fetchCategoriesList()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.SUPPLIES_ITEM_CATEGORIES_LIST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.SUPPLIES_ITEM_CATEGORIES_LIST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(suppliesCategoryListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(suppliesCategoryListError)) {
            setLoading(false)
        }
    }, [suppliesCategoryListSuccess, suppliesCategoryListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (addSuppliesCategoryReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(true)
            displaySuccessToast(addSuppliesCategorySuccess.data?.message)
            fetchCategoriesList()
            setName('')
        } else if (addSuppliesCategoryReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(addSuppliesCategoryError.message)
        }
        if (addSuppliesCategoryReqStatus?.length) {
            dispatch(addSuppliesCategoryRequestStatus(''))
        }
    }, [addSuppliesCategorySuccess, addSuppliesCategoryError, addSuppliesCategoryReqStatus])

    useEffect(() => {
        if (updateSuppliesCategoryDetailReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(true)
            displaySuccessToast(updateSuppliesCategoryDetailSuccess.data?.message)
            fetchCategoriesList()
        } else if (updateSuppliesCategoryDetailReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(updateSuppliesCategoryDetailError.message)
        }
        if (updateSuppliesCategoryDetailReqStatus?.length) {
            dispatch(updateSuppliesCategoryDetailRequestStatus(''))
        }
    }, [updateSuppliesCategoryDetailSuccess, updateSuppliesCategoryDetailError, updateSuppliesCategoryDetailReqStatus])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (!isNull(selectedLocation) && isLoggedInUserBusiness(user)) {
            fetchCategoriesList()
        }
    }, [selectedLocation])

    const fetchCategoriesList = () => {
        setLoading(true)
        const data = {
            businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
            locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation
        }
        dispatch(suppliesCategoryListRequest(data))
    }

    const isPermissionAllowed = (pType) => {
        if (pType === PERMISSION_SUB_TYPE.SUPPLIES.ADD_CATEGORY) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.SUPPLIES, PERMISSION_SUB_TYPE.SUPPLIES.ADD_CATEGORY, employeeSelectedBusiness, employeeSelectedLocation)
        }
    }

    const handleAddCategoryClick = () => {
        setShowAddCategoryModal(true)
    }

    const handleDetailClick = (item) => {
        setSelectedCategory(item)
        setName(item.name)
        setIsActive(item.isActive)
        setShowUpdateCategoryModal(true)
    }

    const handleSubmitClick = () => {
        if (isEmpty(name)) {
            displayErrorToast('Category name cannot be blank')
        } else {
            setLoading(true)
            const data = {
                name: name,
                locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation,
                businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                isActive: isActive,
                productCode: APP_CONSTANTS.PRODUCT_NAME
            }
            dispatch(addSuppliesCategoryRequest(data))
            setShowAddCategoryModal(false)
        }
    }

    const handleUpdateClick = () => {
        if (isEmpty(selectedCategory)) {
            displayErrorToast('Something went wrong. Please try selecting category again and then update.')
        } else if (isEmpty(name)) {
            displayErrorToast('Category name cannot be blank')
        } else {
            setLoading(true)
            const data = {
                suppliesCategoryId: selectedCategory.suppliesCategoryId,
                name: name,
                isActive: isActive
            }
            dispatch(updateSuppliesCategoryDetailRequest(data))
            setShowUpdateCategoryModal(false)
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Categories' />
                {isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                {!isNull(suppliesCategoryListSuccess) && !isEmpty(suppliesCategoryListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">Status</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {suppliesCategoryListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.name}</td>
                                    <td className="text-center">
                                        <div className={element.isActive === true ? 'active' : 'in-active'}>{element.isActive === true ? 'Active' : 'In-Active'}</div>
                                    </td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleDetailClick(element) }}><div className="tr-action-btn">View Details</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(suppliesCategoryListError) && <div className="content-error">{suppliesCategoryListError.message}</div>}
                {isPermissionAllowed(PERMISSION_SUB_TYPE.SUPPLIES.ADD_CATEGORY) && <div className="vl-fab-container" onClick={() => handleAddCategoryClick()}>
                    <img src={require('../../../assets/plus_icon.png')} className="vl-fab-icon" />
                </div>}
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowAddCategoryModal(false) }}
                show={showAddCategoryModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        New Category
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="scl-modal-form-container">
                        <SubTextLabel label='Enter details to add new category' />
                        <CommonInputFloatFull
                            type='text'
                            id='name'
                            onChange={e => setName(e.target.value)}
                            placeholder='Name'
                            value={name}
                        />
                        <CommonCheckbox
                            id='isActive'
                            label='Is category active'
                            value={isActive}
                            onChange={() => {
                                setIsActive(!isActive)
                            }}
                        />
                        <ButtonRow>
                            <CommonButton label='Submit' onClick={() => { handleSubmitClick() }} />
                        </ButtonRow>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                onHide={() => { setShowUpdateCategoryModal(false) }}
                show={showUpdateCategoryModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Update Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="scl-modal-form-container">
                        <SubTextLabel label='Enter details to update category' />
                        <CommonInputFloatFull
                            type='text'
                            id='name'
                            onChange={e => setName(e.target.value)}
                            placeholder='Name'
                            value={name}
                        />
                        <CommonCheckbox
                            id='isActive'
                            label='Is category active'
                            value={isActive}
                            onChange={() => {
                                setIsActive(!isActive)
                            }}
                        />
                        <ButtonRow>
                            <CommonButton label='Submit' onClick={() => { handleUpdateClick() }} />
                        </ButtonRow>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default SuppliesCategoriesList